import React, { useEffect } from 'react'

import { Box, Grid, Paper, Theme, Typography, useMediaQuery } from '@mui/material'
import { makeStyles } from '@mui/styles'
import CalendarWeek from './CalendarWeek'
import useDisplayCalendar from './utils/displayCalendarHook'
import { getAppTheme } from '../../../../shared/config/getAppTheme'
import { useSelector } from 'react-redux'
import { getPrefersDarkMode } from '../../../../store/settings/settings.selectors'

export interface CalendarDayObject {
  month: number
  day: number
  year: number
  date: Date
  weekday: number
  actualDay: boolean
  actualMonth: boolean
}

export interface WeekObject {
  days: CalendarDayObject[]
}

interface IProps {
  selectedDate?: number
  calendarData?: any
  changeSelectedDate?: (date: number) => void
}

const Calendar: React.FC<IProps> = (props) => {
  const darkMode = useSelector(getPrefersDarkMode)
  const useStyles = makeStyles((theme: Theme) => ({
    paper: {
      width: '100%',
      marginTop: theme.spacing(0.8),
      padding: 0,
      overflow: 'hidden',
    },
    calendarDays: {},
    calendarDaysHeadline: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'nowrap',
      width: '100%',
      backgroundColor: darkMode ? theme.palette.primary.dark : theme.palette.primary.main,
    },
    calendarDaysWeekday: {
      width: '15%',
      maxWidth: '15%',
      textAlign: 'center',
      verticalAlign: 'middle',
      height: '40px',
      textTransform: 'uppercase',
      borderRight: `1px solid ${darkMode ? '#8a8a8a' : '#f5f5f5'}`,
      padding: '5px',
      // color: darkMode ? theme.typography. : theme.palette.primary.contrastText,
      lineHeight: '33px',
      '&:last-child': {
        borderRight: 'none',
      },
    },
    backgroundLayer: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgb(255,255,255,0.6)',
    },
    preloader: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
    },
  }))
  const classes = useStyles()
  const theme: Theme = getAppTheme()
  // const downSm = useMediaQuery(theme.breakpoints.down('sm'))
  const downMd = useMediaQuery(theme.breakpoints.down('md'))

  const DaysOfWeek = [
    'Montag',
    'Dienstag',
    'Mittwoch',
    'Donnerstag',
    'Freitag',
    'Samstag',
    'Sonntag',
  ]

  const [selectedDate, setSelectedDate] = React.useState<number>(props.selectedDate ? props.selectedDate : Date.now())
  const [completeCalendarWeeks, setCompleteCalendarWeeks] = useDisplayCalendar()

  useEffect(() => {
    props.selectedDate && setSelectedDate(props.selectedDate)
  }, [props.selectedDate],
  )

  useEffect(() => {
    setCompleteCalendarWeeks(selectedDate)
  }, [selectedDate],
  )

  const handleSetSelectedDate = (selectedDate: number) => {
    setSelectedDate(selectedDate)
  }

  return (
    <Grid
      container
      direction='row'
      sx={{ width: '100%' }}
    >
      <Grid container item xs={12} sx={{ width: '100%' }}>
        <Paper className={classes.paper}>
          <Grid item xs={12} sx={{ width: '100%' }}>
            <Box className={classes.calendarDays} component='div'>
              <Box className={classes.calendarDaysHeadline} component='div'>
                {DaysOfWeek.map((day, index) => {
                  return (
                    <Box key={index} className={classes.calendarDaysWeekday} component='div'>
                      <Typography
                        component='span'
                        variant='body2'
                      >{downMd ? day.charAt(0).toUpperCase() : day}
                      </Typography>
                    </Box>
                  )
                })}
              </Box>
              <Box component='div'>
                {completeCalendarWeeks && completeCalendarWeeks.map((week: WeekObject, index: number) => {
                  return (
                    <CalendarWeek
                      key={index}
                      index={index}
                      week={week}
                      setSelectedDate={handleSetSelectedDate}
                      calendarData={props.calendarData}
                    />
                  )
                })}
              </Box>
            </Box>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  )
}
export default Calendar
